import { render, staticRenderFns } from "./AttachedFileView.vue?vue&type=template&id=a5e99a44&scoped=true"
import script from "./AttachedFileView.vue?vue&type=script&lang=js"
export * from "./AttachedFileView.vue?vue&type=script&lang=js"
import style0 from "./AttachedFileView.vue?vue&type=style&index=0&id=a5e99a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e99a44",
  null
  
)

export default component.exports